<template>
  <div class="app flex-row align-items-center my-4 mx-5">
    <table class="mainTable h-100 w-100">
      <div style="border: 0px solid">
        <thead style="font-family: iransans">
          <v-row
            id="header"
            class="d-flex justify-content-between align-center"
          >
            <v-col cols="12">
              <div class="d-flex justify-space-between">
                <div class="me-8"></div>
                <span class="text-center font-weight-bold ms-16"
                  >صورتحساب فروش کالا و خدمات</span
                >
                <span class="text-left me-3">
                  شماره: {{ invoice.invoiceCode }}
                </span>
              </div>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title
                  class="white black--text d-flex justify-center"
                  style="font-size: 12px"
                  >مشخصات فروشنده</v-card-title
                >
                <hr />
                <v-card-text>
                  <v-row class="text-center">
                    <v-col cols="4" class="d-flex">
                      <img
                        src="../assets/images/big.png"
                        alt=""
                        v-show="invoice.isLogoShow"
                        style="width: 50%; height: 40px !important"
                      />
                    </v-col>
                    <v-col cols="4" class="text-center">
                      <div style="font-size: 12px">
                        <span>شماره اقتصادی: </span>
                        <span> {{ invoice.economicalNo }}</span>
                      </div>
                    </v-col>
                    <v-col cols="4" class="text-center" style="font-size: 12px">
                      <span>تاریخ: </span>
                      <span>{{ invoice.registerDate }}</span>
                    </v-col>
                  </v-row>
                  <v-row class="text-center">
                    <v-col cols="4"></v-col>
                    <v-col cols="4">
                      <div style="font-size: 12px">
                        <span>کد پستی: </span>
                        <span>{{ invoice.postalCode }}</span>
                      </div>
                    </v-col>
                    <v-col cols="4" style="font-size: 12px">
                      <span> شماره ثبت/ شماره ملی: </span>
                      <span>{{ invoice.nationalId }}</span>
                    </v-col>
                  </v-row>
                  <v-row class="text-center">
                    <v-col class="text-right" cols="8" style="font-size: 12px">
                      <span>آدرس: </span>
                      <span>{{ invoice.address }}</span>
                    </v-col>
                    <v-col cols="4" style="font-size: 12px">
                      <span>تلفن یا نمابر: </span>
                      <span dir="ltr">{{ invoice.tel }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card class="mt-5">
                <v-card-title
                  class="white black--text d-flex justify-center"
                  style="font-size: 12px"
                  >مشخصات خریدار</v-card-title
                >
                <hr />
                <v-card-text>
                  <v-row class="text-center">
                    <v-col cols="4" style="font-size: 12px">
                      <span> نام شخص حقیقی/ حقوقی: </span>
                      <span>
                        {{ invoice.customerName }}
                      </span>
                    </v-col>
                    <v-col cols="4" class="text-center" style="font-size: 12px">
                      <span>شماره اقتصادی: </span>
                      <span>{{ invoice.customerEconomicalCode }}</span>
                    </v-col>
                    <v-col style="font-size: 12px">
                      <span>شماره ثبت/ شماره ملی: </span>
                      <span>{{ invoice.customerNationalId }}</span>
                    </v-col>
                  </v-row>
                  <v-row class="text-center">
                    <v-col cols="4">
                      <span class="me-2" style="font-size: 12px">
                        <span>استان: </span>
                        <span>{{ invoice.stateName }}</span>
                      </span>
                    </v-col>
                    <v-col cols="4">
                      <span class="me-2" style="font-size: 12px">
                        <span>شهرستان: </span>
                        <span>{{ invoice.province }}</span>
                      </span>
                    </v-col>
                    <v-col cols="4">
                      <span style="font-size: 12px">
                        <span> شهر: </span>
                        <span>{{ invoice.cityName }}</span>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row class="text-center">
                    <v-col cols="4" style="font-size: 12px">
                      <span>کد پستی: </span>
                      <span>{{ invoice.customerPostalCode }}</span>
                    </v-col>
                    <v-col cols="4">
                      <span dir="rtl" style="font-size: 12px">
                        <span>آدرس: </span>
                        <span>{{ invoice.CustomerAddress }}</span>
                      </span>
                    </v-col>
                    <v-col cols="4">
                      <span dir="ltr" style="font-size: 12px">
                        <span>تلفن یا نمابر: </span>
                        <span>{{ invoice.CustomerTel }}</span>
                      </span>
                    </v-col>
                  </v-row>
                  <!-- <v-row class="mt-6">
                  <v-col cols="12" class="d-flex justify-end me-4">
                    <v-btn class="warning" v-show="false" @click="editCustomerDialog()"
                      >ویرایش</v-btn
                    >
                  </v-col>
                </v-row> -->
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </thead>
        <tfoot style="font-family: iransans">
          <hr />
          <v-row style="direction: ltr">
            <v-col cols="6" class="text-center">
              <p
                class="me-2 text-center d-flex mt-4"
                style="direction: rtl !important; font-weight: bold"
              >
                <span>توضیحات: </span>
                <span class="me-2" v-html="invoice.description"></span>
              </p>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="6">
              <p class="mt-4" style="font-weight: bold; font-size: 12px">
                شرایط و نحوه فروش:
                {{ invoice.cash ? "نقدی" : "غیر نقدی" }}
              </p>
            </v-col>
          </v-row>
          <hr />
          <v-row>
            <v-col>
              <span>مهر و امضا فروشنده</span>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <span>مهر و امضا خریدار</span>
            </v-col>
          </v-row>
          <hr />
        </tfoot>
        <tbody>
          <v-row class="mx-3"> </v-row>
          <hr />

          <b-table
            responsive
            show-empty
            :items="invoice.list"
            :fields="originalOrderFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table"
            style="font-family: Tahoma !important"
            small
          >
            <template v-slot:head()="data">
              <div
                dir="ltr"
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma !important;
                "
              >
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                dir="ltr"
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma !important;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma !important;
                "
              >
                {{ data.index + 1 }}
              </div>
            </template>
            
            <template v-slot:cell(perPrice)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(price)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(discount)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(discountPrice)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(tax)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
                  <template v-slot:cell(payPrice)="data">
                    <div
                      style="
                        text-align: center;
                        vertical-align: middle;
                        font-family: Tahoma !important;
                      "
                    >
                      {{ data.value.toLocaleString() }}
                    </div>
                  </template>
            <template #custom-foot="data">
              <b-tr>
                <b-th colspan="6">جمع کل</b-th>
                <b-th>{{
                  invoice.totalPrice ? invoice.totalPrice.toLocaleString() : 0
                }}</b-th>
                <b-th class="text-center">{{
                  invoice.totalDiscount
                    ? invoice.totalDiscount.toLocaleString()
                    : 0
                }}</b-th>
                <b-th class="text-center">{{
                  invoice.totoalDiscountPrice
                    ? invoice.totoalDiscountPrice.toLocaleString()
                    : 0
                }}</b-th>
                <b-th class="text-center">{{
                  invoice.totoalTax ? invoice.totoalTax.toLocaleString() : 0
                }}</b-th>
                <b-th class="text-center">{{
                  invoice.totalPayPrice
                    ? invoice.totalPayPrice.toLocaleString()
                    : 0
                }}</b-th>
              </b-tr>
            </template>
          </b-table>
        </tbody>
      </div>
    </table>
  </div>
</template>

<script>
import Axios from "axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      sellerInfo: {
        economicalNumber: "411333598578",
        nationalNumber: "10102143437",
        postalCode: "3393164519",
        address:
          "جاده خراسان - شهرک صنعتی عباس‌آباد، خیابان دلگشا، خیابان جامی، کوچه 1/2، پلاک844",
        phone: "(021)36425404-5",
      },
      registerDate: "",
      currentDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      customerPriorities: [
        { value: "VIP", text: "VIP" },
        { value: "معمولی", text: "معمولی" },
        { value: "لیست سیاه", text: "لیست سیاه" },
      ],
      invoice: {
        customerName: "",
        customerNameEn: "",
        customerPriority: "",
        customerMobile: "",
        customerEmail: "",
        stateId: "",
        cityId: "",
        address: "",
        economicalNumber: "",
        nationalNumber: "",
        postalCode: "",
        phone: "",
        pay: "",
        description: "",
        items: [],
      },
      progress: false,
      states: [],
      cities: [],
      stateLoading: false,
      cityLoading: false,
      payOptions: [
        { value: true, text: "نقدی" },
        { value: false, text: "غیر نقدی" },
      ],
      guide: false,
      isBusy: false,
      showResultTable: false,
      valueWhenIsEmpty: "",
      options: {
        decimal: ",",
        thousands: ",",
        precision: 0,
        length: 16,
      },
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      invoiceInfo: {
        list: [],
      },
      originalOrderFields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "کد کالا" },
        { key: "description", label: "شرح کالا یا خدمات" },
        { key: "number", label: "تعداد/مقدار" },
        { key: "measurementUnit", label: "واحد اندازه گیری" },
        { key: "perPrice", label: "مبلغ واحد" },
        { key: "price", label: "مبلغ کل" },
        { key: "discount", label: "مبلغ تخفیف" },
        { key: "discountPrice", label: "مبلغ کل پس از تخفیف (ریال)" },
        { key: "tax", label: "جمع مالیات و عوارض (ریال)" },
        {
          key: "payPrice",
          label: "مبلغ نهایی (ریال)",
        },
      ],
      finalInvoiceFields: [],
      isBusy: false,
      invoiceHasIndex: false,
    };
  },
  methods: {
    showInvoice() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/accounting/invoice/getInfo",
        {
          invoiceId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.invoice = res.data.invoice;
            this.finalInvoiceFields = this.originalOrderFields;
            if (this.invoice.list && this.invoice.list.length) {
              let totalCodes = this.invoice.list.map((x) => x.code);
              totalCodes = totalCodes.reduce((a, b) => a + b);
              if (totalCodes && totalCodes.length) {
                this.invoiceHasIndex = true;
              } else {
                this.finalInvoiceFields = this.finalInvoiceFields.filter(
                  (x) => x.key != "code"
                );
              }
            }
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
  },
  computed: {
    computedTotalPrice() {
      return this.invoice.orderItems
        ? this.invoice.orderItems
            .map((item) => item.perPrice * item.number)
            .reduce((a, b) => {
              return a + b;
            })
        : [];
    },
  },
  mounted() {
    this.showInvoice();
  },
};
</script>
<style>
p {
  font-family: iransans;
}

td {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
}

@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>

<style scoped>
p,
div {
  line-height: 1rem;
}

thead {
  background-color: white;
  color: black;
}

@media print {
  @page {
    margin: 0;
    size: a4 portrait !important;
    font-size: 30%;
    text-color: black;
    margin: 50px;
  }

  body {
    margin: 1.6cm;
  }

  table {
    border: 1px solid;
  }

  table.mainTable {
    border: 0px !important;
  }

  /* tfoot:after {
      counter-increment: page;
      content: "صفحه " counter(page);
    } */
}
</style>
